/**
 * Elevante.AI Icon-Only Mark
 *
 * Used in the collapsed sidebar where only the square icon fits. Renders
 * the new favicon PNG via <img>. The `invertColors` prop is kept as a
 * no-op for API compatibility with the previous SVG version.
 */

import React from 'react';

const ElevanteIconSVG = ({ className = "h-8 w-8", invertColors = false }) => {
  void invertColors;
  return (
    <img
      src="/elevante-favicon.png"
      alt="Elevante.AI"
      className={className}
      draggable={false}
    />
  );
};

export default ElevanteIconSVG;
